const setError = (state, error) => {
  state.error = error;
};

const setStatus = (state, status) => {
  state.status = status;
};

export default {
  setError,
  setStatus,
};
